import { useState } from "react";

import { Input, Modal, ModalProps, Option, Select, Stack } from "@introist/react-foundation/v2";

import { FormFooter } from "../../../../../datasources/components/FormFooter";
import { TUserRole } from "services/rpc/RpcProvider";

type InviteUserModalProps = ModalProps & {
  onAddUser: (email: string, role: TUserRole) => Promise<unknown>;
  organisationLogo?: string | null;
};

export const InviteUserModal = ({
  onAddUser,
  organisationLogo,
  ...props
}: InviteUserModalProps) => {
  return (
    <Modal
      title="Invite User to your workspace"
      style={{
        width: 512
      }}
      {...props}
    >
      {props.open && (
        <InviteForm onCancel={() => props.onClose && props.onClose()} onSubmit={onAddUser} />
      )}
    </Modal>
  );
};

const ROLE_OPTIONS: Option[] = [
  { key: "user" as TUserRole, title: "User" },
  { key: "admin" as TUserRole, title: "Admin" },
  { key: "owner" as TUserRole, title: "Owner" }
];

const InviteForm = ({
  onSubmit,
  onCancel
}: {
  onSubmit: (email: string, role: TUserRole) => Promise<unknown>;
  onCancel: () => void;
}) => {
  const [email, setEmail] = useState("");
  const [role, setRole] = useState<TUserRole>("user" as TUserRole);

  return (
    <Stack vertical>
      <Input type="text" placeholder="email@company.com" value={email} onChange={setEmail} />
      <Select
        options={ROLE_OPTIONS}
        value={role}
        onSelect={option => setRole(option.key as TUserRole)}
        placeholder="Role"
      />
      <FormFooter
        onCancel={onCancel}
        onSubmit={async () => {
          await onSubmit(email, role);
        }}
        submit="Invite"
      />
    </Stack>
  );
};
